import { render, staticRenderFns } from "./SessionOverlaps.vue?vue&type=template&id=e4509d9c&"
import script from "./SessionOverlaps.vue?vue&type=script&lang=js&"
export * from "./SessionOverlaps.vue?vue&type=script&lang=js&"
import style0 from "./SessionOverlaps.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports